<!-- Link to Policies -->
<section class="lightToMidGradientBackground">
	<div class="row policyLinks centerLinkInDiv">
		<button class="btn btn-dark pdrButton buttonMargin" routerLink="/terms">Terms and Conditions</button>
		<button class="btn btn-dark pdrButton buttonMargin" routerLink="/privacy">Privacy Policy</button>
		<button class="btn btn-dark pdrButton buttonMargin" routerLink="/guidelines">Community Guidelines</button>
	</div>
</section>